import styled from '@emotion/styled';

export const StyledMaxWidth = styled.div(({ theme }) => ({
    margin: `0 auto`,
    maxWidth: theme.sizes.pageMaxWidth,
    width: '100%',
}));
